import React,{useState} from 'react'
import Layout from 'components/Layouts'
import { createTheme,MuiThemeProvider } from '@material-ui/core'
import List from './list'
import Detail from './detail/detail'
import './style.css'
import Peta from './peta/peta'
import {Helmet} from "react-helmet";

const themeButton = createTheme({ 
    palette: { 
        primary: {
            main:'#00a1ed',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main:'#4cc614',
            contrastText: '#FFFFFF',
        }
    } 
})
export default function Index({tabs='list',...props}) {
    const [tab, settab] = useState(tabs)
    const tabToggle=(key)=>{
        settab(key)
    }
    return (
        <Layout>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Manajemen Talenta</title>
                <meta
                    name="description"
                    content="Manajemen Talenta powered by ONE GML"
                /> 
                <link rel="icon" href="/altius.png" />
                <link rel="canonical" href="https://apps.onegml.com/talenta" />
            </Helmet>
            <MuiThemeProvider theme={themeButton}>
                {tab==='list'&&<List tab={tab} tabToggle={tabToggle} {...props} />}
                {tab==='detail'&&<Detail tab={tab} tabToggle={tabToggle} {...props} />}
                {tab==='peta'&&<Peta tab={tab} tabToggle={tabToggle} {...props} />}
            </MuiThemeProvider>
        </Layout>
    )
}
